import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GraduationCap, Users, Clock, CalendarClock } from "lucide-react";
import api from "@/lib/api";

export default function LiveClassesPage() {
  const navigate = useNavigate();
  const [classes, setClasses] = useState(null);

  useEffect(() => {
    api.get("/meetings").then((r) => setClasses(r.data.filter((m) => m.meeting_type === "class"))).catch(() => setClasses([]));
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-8" data-testid="live-classes-page">
      <h1 className="font-heading text-2xl font-semibold text-white flex items-center gap-2"><GraduationCap className="w-6 h-6 text-fuchsia-400" /> Live Classes</h1>
      <p className="text-sm text-slate-400 mt-1">All your cohort classes, hosted or attended — students join as audio-only viewers with a raise-hand flow.</p>

      <div className="glass-panel rounded-2xl divide-y divide-white/5 mt-6" data-testid="live-classes-list">
        {classes === null && <p className="p-6 text-sm text-slate-400 text-center">Loading...</p>}
        {classes?.length === 0 && <p className="p-6 text-sm text-slate-400 text-center">No live classes yet — create one from the Meetings page.</p>}
        {classes?.map((m) => (
          <div key={m.id} className="flex items-center gap-3 p-4 flex-wrap" data-testid={`class-row-${m.id}`}>
            <GraduationCap className="w-4 h-4 text-fuchsia-400 shrink-0" />
            <span className="flex-1 text-sm text-white truncate min-w-[140px]">{m.title}</span>
            {m.scheduled_at && <span className="text-xs text-slate-400 flex items-center gap-1"><CalendarClock className="w-3 h-3" /> {new Date(m.scheduled_at).toLocaleString(undefined, { hour: "numeric", minute: "2-digit", month: "short", day: "numeric" })}</span>}
            <span className="text-xs text-slate-400 flex items-center gap-1"><Users className="w-3 h-3" /> {m.participant_count}</span>
            <span className="text-xs text-slate-500 flex items-center gap-1"><Clock className="w-3 h-3" /> {m.status}</span>
            {m.status !== "ended" && (
              <button onClick={() => navigate(`/meeting/${m.id}`)} data-testid={`class-join-btn-${m.id}`} className="text-xs font-semibold bg-fuchsia-500/20 text-fuchsia-300 hover:bg-fuchsia-500/30 px-3 py-1.5 rounded-lg">Open</button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
